import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Hugo element, used to display HuGo in different states (to be used in mainmenu)
 *
 *  @prop {Boolean} default - optional, used to display the default (neutral) HuGo
 *  @prop {Boolean} alert - optional, used to display HuGo with an alert indication
 *  @prop {Boolean} success - optional, used to display happy HuGo
 *  @prop {Boolean} info - optional, used to display the HuGo with information indication
 *  @prop {Boolean} error - optional, used to display the HuGo with an error indication
 *
 */
let SDBNavHuGo = class SDBNavHuGo extends LitElement {
    constructor() {
        super(...arguments);
        this.default = false;
        this.alert = false;
        this.success = false;
        this.info = false;
        this.error = false;
    }
    render() {
        return html `
            ${this.default
            ? html `<img src="../img/hugo-default.svg" alt="HuGo" />`
            : html ``}
            ${this.alert
            ? html `<img src="../img/hugo-alert.svg" alt="HuGo" />`
            : html ``}
            ${this.success
            ? html `<img src="../img/hugo-success.svg" alt="HuGo" />`
            : html ``}
            ${this.info
            ? html `<img src="../img/hugo-info.svg" alt="HuGo" />`
            : html ``}
            ${this.error
            ? html `<img src="../img/hugo-error.svg" alt="HuGo" />`
            : html ``}
        `;
    }
};
SDBNavHuGo.styles = [
    elements,
    css `
            :host img {
                height: 56px;
                width: auto;
                padding: 7px 0;
                cursor: pointer;
            }
        `,
];
__decorate([
    property({ type: Boolean })
], SDBNavHuGo.prototype, "default", void 0);
__decorate([
    property({ type: Boolean })
], SDBNavHuGo.prototype, "alert", void 0);
__decorate([
    property({ type: Boolean })
], SDBNavHuGo.prototype, "success", void 0);
__decorate([
    property({ type: Boolean })
], SDBNavHuGo.prototype, "info", void 0);
__decorate([
    property({ type: Boolean })
], SDBNavHuGo.prototype, "error", void 0);
SDBNavHuGo = __decorate([
    customElement('sdb-nav-hugo')
], SDBNavHuGo);
export { SDBNavHuGo };
//# sourceMappingURL=sdb-nav-hugo.js.map